import React from 'react';
import { color } from 'theme';

export const PrevArrowIcon = ({ fill = color.red }) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    style={{ width: '100%', height: '100%' }}
    viewBox="0 0 58 180"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 45 15 L 13 90 L 45 165"
      fill="none"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
);

// TWEAKING GUIDE:
// strokeWidth: 2.5 = thickness (try 2-4)
// Path coordinates: "M 30 60 L 10 125 L 30 190"
//   - First number (30): horizontal position of arrow tips (lower = more left)
//   - Second/Fourth numbers (60, 190): vertical start/end (closer = shorter arrow)
//   - Middle (10, 125): arrow point position (lower = sharper angle)
